import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_55d0t9jb: FaireBrandEntity = {
  token: "b_55d0t9jb",
  type: "brand",
  name: "NOTICE Hair Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/3d6169504ecc6e29b8d1c998805752405fa154b8c85e7de25bb4af9ba20fcbfa.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4e9b6c65e4552d08ed02be5cdb6e28daa4bd29cfaf000d6196747bdaf2be8042.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/3d6169504ecc6e29b8d1c998805752405fa154b8c85e7de25bb4af9ba20fcbfa.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4e9b6c65e4552d08ed02be5cdb6e28daa4bd29cfaf000d6196747bdaf2be8042.jpeg",
  location: " Calgary , AB, CAN",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 16,
  isInsider: false,
  description:
    "We're NOT!CE Hair Co., a leading hair care company with purpose, for hair that gets noticed, and waste that doesn't. By honoring ego, experience, and Earth through noticeable results, we're freeing the planet from plastic waste. Our plastic-free bars prevent 3+ plastic bottles AND we collect other companies’ trash, 10 ocean-bound plastic bottles, to be exact. So lather on, noticeable results are just a shower away.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:29.426Z",
    importedBy: "entity-db-cli",
  },
};
